import { render, staticRenderFns } from "./markBack.vue?vue&type=template&id=aa0b981c&scoped=true"
import script from "./markBack.vue?vue&type=script&lang=js"
export * from "./markBack.vue?vue&type=script&lang=js"
import style0 from "./markBack.vue?vue&type=style&index=0&id=aa0b981c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b981c",
  null
  
)

export default component.exports